import createIcon from '../../createIcon';

/**
 * @component @name WebStories
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNzUgNEMxNy44NSA0IDE4Ljc1IDQuOSAxOC43NSA2VjE4QzE4Ljc1IDE5LjEgMTcuODUgMjAgMTYuNzUgMjBWNFpNMS43NSAyMEMxLjc1IDIxLjEgMi42NSAyMiAzLjc1IDIySDEyLjc1QzEzLjg1IDIyIDE0Ljc1IDIxLjEgMTQuNzUgMjBWNEMxNC43NSAyLjkgMTMuODUgMiAxMi43NSAySDMuNzVDMi42NSAyIDEuNzUgMi45IDEuNzUgNFYyMFpNMjAuNzUgMThDMjEuNTggMTggMjIuMjUgMTcuMzMgMjIuMjUgMTYuNVY3LjVDMjIuMjUgNi42NyAyMS41OCA2IDIwLjc1IDZWMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WebStories = createIcon('WebStories', [
  [
    'path',
    {
      d: 'M16.75 4C17.85 4 18.75 4.9 18.75 6V18C18.75 19.1 17.85 20 16.75 20V4ZM1.75 20C1.75 21.1 2.65 22 3.75 22H12.75C13.85 22 14.75 21.1 14.75 20V4C14.75 2.9 13.85 2 12.75 2H3.75C2.65 2 1.75 2.9 1.75 4V20ZM20.75 18C21.58 18 22.25 17.33 22.25 16.5V7.5C22.25 6.67 21.58 6 20.75 6V18Z',
      key: '10inq6',
    },
  ],
]);

export default WebStories;
